module.exports = __webpack_public_path__ + "static/media/compare-button-selected-all.6218ff61.svg";